var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "grey",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.0108C2.73478 2.0108 2.48043 2.11673 2.29289 2.30527C2.10536 2.49382 2 2.74955 2 3.0162V14.0756C2 14.3422 2.10536 14.598 2.29289 14.7865C2.48043 14.9751 2.73478 15.081 3 15.081H17C17.2652 15.081 17.5196 14.9751 17.7071 14.7865C17.8946 14.598 18 14.3422 18 14.0756V6.0324C18 5.76575 17.8946 5.51002 17.7071 5.32147C17.5196 5.13292 17.2652 5.027 17 5.027H10C9.73478 5.027 9.48043 4.92107 9.29289 4.73252L6.58579 2.0108H3ZM0.87868 0.883424C1.44129 0.317777 2.20435 0 3 0H7C7.26522 0 7.51957 0.105926 7.70711 0.294475L10.4142 3.0162H17C17.7957 3.0162 18.5587 3.33398 19.1213 3.89962C19.6839 4.46527 20 5.23245 20 6.0324V14.0756C20 14.8755 19.6839 15.6427 19.1213 16.2084C18.5587 16.774 17.7957 17.0918 17 17.0918H3C2.20435 17.0918 1.44129 16.774 0.87868 16.2084C0.31607 15.6427 0 14.8755 0 14.0756V3.0162C0 2.21625 0.31607 1.44907 0.87868 0.883424Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder2);
export default __webpack_public_path__ + "static/media/folder2.53ac1036.svg";
export { ForwardRef as ReactComponent };